// extracted by mini-css-extract-plugin
export default {"icon":"EmptyPane-module__icon___3cSOX","root":"EmptyPane-module__root___2dmKz"};